module.exports = __webpack_public_path__ + "static/img/100870.740dec46.png";